import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.jsx'; // Ensure the correct case is used

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
